import { toast } from "react-toastify";

const ErrorMessage = (props) => {
  return toast(props.message, {
    type: toast.TYPE.ERROR,
    position: toast.POSITION.BOTTOM_LEFT,
  });
};

export default ErrorMessage;
